import SurveyStep from "./SurveyStep";
import LanguageStep from "./LanguageStep";
import SurveyTranslationStep from "./SurveyTranslationStep";
import AgreementStep from "./AgreementStep";
import SectionStep from "./SectionStep";
import QuestionStep from "./QuestionStep";
import HelpDocStep from "./HelpDocStep";
import NotificationEmailStep from "./NotificationEmailStep";
import ReviewStep from "./ReviewStep";
import SaveOrPublishStep from "./SaveOrPublishStep";
import ReportConfigurationStep from "./reportConfigurationStep";
import { SELF_SERVICE_STEP_TITLES } from "../../../../utils/surveyLiterals";

const Steps = (props) => {
  switch (props.currentStep.title) {
    case SELF_SERVICE_STEP_TITLES.SURVEY_STEP:
      return <SurveyStep {...props} />;
    case SELF_SERVICE_STEP_TITLES.LANGUAGE_STEP:
      return <LanguageStep {...props} />;
    case SELF_SERVICE_STEP_TITLES.SURVEYTRANSLATION_STEP:
      return <SurveyTranslationStep {...props} />;
    case SELF_SERVICE_STEP_TITLES.AGREEMENT_STEP:
      return <AgreementStep {...props} />;
    case SELF_SERVICE_STEP_TITLES.SECTION_STEP:
      return <SectionStep {...props} />;
    case SELF_SERVICE_STEP_TITLES.QUESTION_STEP:
      return <QuestionStep {...props} />;
    case SELF_SERVICE_STEP_TITLES.HELPDOCSTEP:
      return <HelpDocStep {...props} />;
    case SELF_SERVICE_STEP_TITLES.NOTIFICATION_EMAIL:
      return <NotificationEmailStep {...props} />
    case SELF_SERVICE_STEP_TITLES.REVIEW_STEP:
      return <ReviewStep {...props} />;
    case SELF_SERVICE_STEP_TITLES.SAVEORPUBLISH_STEP:
      return <SaveOrPublishStep {...props} />;
    case SELF_SERVICE_STEP_TITLES.REPORT_CONFIGURATION_STEP:
      return <ReportConfigurationStep {...props} />;
  }
};

export default Steps;
